
import Vue from "vue";
import Component from "vue-class-component";
import BaseApp from "@/BaseApp.vue";
import Success from "@/shared/notifications/Success.vue";
import Error from "@/shared/notifications/Error.vue";
import PostInscription from "./PostInscription.vue";
import FormInscription from "./FormInscription.vue";

import { C } from "./controller";
import { InscriptionSimple, MetaInscription } from "@/shared/logic/types";
import { ValidEvent } from "@/shared/utils";

const AppSimpleProps = Vue.extend({
  props: {
    meta: Object as () => MetaInscription
  }
});

@Component({
  components: { BaseApp, PostInscription, FormInscription, Success, Error }
})
export default class AppSimple extends AppSimpleProps {
  output = C.notifications;

  inscriptionDone = false;

  async save(event: ValidEvent, insc: InscriptionSimple) {
    event.spinning = true;
    const ok = await C.envoiInscription(insc);
    if (ok) {
      this.inscriptionDone = true;
    }
    event.spinning = false;
  }
}
